<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			nome-botao-confirmar="Salvar"
			:is-confirmar-visivel="isConfirmarVisivel"
			:custom-actions="false"
			:max-width="largura"
			:acao-cancelar="fecharModal"
			:acao-confirmar="confirmar"
			:is-confirmar-desabilitado="!formIsValid"
			@close="fecharModal"
		>
			<template #body>
				<div :class="{ ajustar_modal_bloquear_ata: !$vuetify.breakpoint.mobile }">
					<v-row class="mt-1 mb-2">
						<v-col cols="12">
							<label-personalizado
								nome-campo="Motivo"
								obrigatorio-por-padrao
								class="mb-2"
							></label-personalizado>
							<v-textarea
								ref="justificativa"
								v-model="justificativa"
								placeholder="Informe o motivo"
								:rules="regras"
								rows="2"
								counter="300"
								class="ma-0 py-0"
								no-resize
								@input="corrigirTexto"
							></v-textarea>
						</v-col>
					</v-row>
				</div>
			</template>
		</modal>
	</v-form>
</template>

<script>
import { actionTypes } from '@/core/constants'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { mapState } from 'vuex'
import validacaoAta from '@/views/mixins/validacaoAta'

export default {
	name: 'modal-bloquear-ata',
	mixins: [validacaoFormulario, validacaoAta],
	props: {
		exibir: {
			type: Boolean,
		},
	},
	data() {
		return {
			justificativa: '',
			isConfirmarVisivel: true,
			formIsValid: true,
			largura: 450,
			regras: [
				(value) => this.regraObrigatoriedade(value, 'O motivo é obrigatório.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						300,
						'O campo de justificativa deve ser igual ou menor que 300 caracteres!',
					),
			],
		}
	},
	computed: {
		...mapState({
			informacoesAta: (state) => state.ata.informacoesAta,
		}),
		tituloModal() {
			if (!this.estaBloqueada(this.informacoesAta)) return 'Bloquear Ata'
			return 'Desbloquear Ata'
		},
	},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},

		async confirmar() {
			if (this.$refs.form.validate()) {
				if (this.estaEfetivado(this.informacoesAta) && !this.estaBloqueada(this.informacoesAta)) {
					await this.bloquearAta()
				} else {
					await this.desbloquearAta()
				}
			}
		},
		async bloquearAta() {
			await this.$store.dispatch(actionTypes.ATA.BLOQUEAR_ATA, this.montarEnvioDispatch())
			await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.informacoesAta.id)
			this.$refs.form.reset()
			await this.fecharAposConfirmacao()
		},
		async desbloquearAta() {
			await this.$store.dispatch(actionTypes.ATA.DESBLOQUEAR_ATA, this.montarEnvioDispatch())
			await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.informacoesAta.id)
			this.$refs.form.reset()
			await this.fecharAposConfirmacao()
		},
		async fecharAposConfirmacao() {
			this.mostrarNotificacaoSucessoDefault()
			this.fecharModal()
		},
		montarEnvioDispatch() {
			return {
				idAta: this.informacoesAta.id,
				justificativa: this.justificativa,
			}
		},
		corrigirTexto() {
			this.justificativa && this.justificativa.trim()
		},
	},
}
</script>

<style lang="stylus" scoped></style>
